module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.143/css/toolsmenu.css"